<textarea class="input" [ngModel]="value" [placeholder]="placeholder" (ngModelChange)="updateValue($event)"
    (keypress)="onSubmit($event)" [rows]="rows" [attr.enterkeyhint]="enterkeyhint"></textarea>